'use client';
import './style.sass';

import React from 'react';
import {
    listMicrofrontend,
    listPath,
    listRealization,
    listStages,
    listTitle,
    listChallenges,
    listReviewTitle,
    listReviewAuthor,
    listReview,
    listReviewIcon,
    listRalization,
} from './constans';
import TitleCase from '../../case-components/title-case';
import Target from '../reusable-components/layouts-component__rgs/target';
import Solution from '../reusable-components/layouts-component__rgs/solution';
import LayoutPage from '../reusable-components/layouts-component__rgs/layout-page';
import Marker from '../reusable-components/layouts-component__rgs/marker';
import Realization from '../reusable-components/layouts-component__rgs/Realization';
import MicroFrontend from '../reusable-components/layouts-component__rgs/microfrontend';
import Challenges from '../reusable-components/layouts-component__rgs/challenges';
import Team from '../reusable-components/layouts-component__rgs/team';
import Review from '../reusable-components/layouts-component__rgs/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

const Rgs = () => {
    const casePathname = '/cases/development/rgs';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <TitleCase
                img="/images/pic/rgs/rgs.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="aimed"
            />
            <Target />
            <Solution />
            <LayoutPage listStages={listStages} />
            <Marker />
            <Realization list={listRalization} listStages={listRealization} />
            <MicroFrontend list={listMicrofrontend} />
            <Challenges list={listChallenges} />
            <Team />
            <Review
                title={listReviewTitle}
                author={listReviewAuthor}
                list={listReview}
                logoSrc={listReviewIcon}
            />
            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
};

export default Rgs;
